import React, { useState, useEffect, memo, useMemo } from 'react';
import { Modal, Button, Form, Row, Col, Alert } from 'react-bootstrap';
import ClipLoader from 'react-spinners/ClipLoader';
import { edsringMerchantId, rearrangeAgentFields } from '../../../utils';
import { decrypt, encryptionByAES } from '../../../utils/encodingdecoding';
import {
	getSchemaList,
	SendGridEmail,
	updateCustomer,
} from '../../../actions/auth';
import swal from 'sweetalert';
import {
	checkCustomerPLPID,
	customerRegistrations,
	customerView,
	getCustomerPortalSetting,
	getEmailTemplateSetting,
} from '../campaigns/services';
import { Link } from 'react-router-dom';
import { clearCustomer, getCustomer } from '../../../actions/customer';
import { useDispatch } from 'react-redux';
import { generatePLPPrimeID } from '../../../utils/helper';

function CustomerAddEditModal({
	isEdit,
	isEditToolTip,
	customerData,
	fetchData,
	testAccounts,
}) {
	const [showModal, setShowModal] = useState(false);
	const [isEditMode, setIsEditMode] = useState(false);
	const [apiError, setApiError] = useState(null);
	const [loading, setLoading] = useState(false);
	const [selectedCustomer, setSelectedCustomer] = useState(null);

	const [schema, setSchema] = useState({});
	let id = decrypt(localStorage.getItem('Id'));
	const [formData, setFormData] = useState({});
	const [errors, setErrors] = useState({});
	const [customerStatus, setCustomerStatus] = useState('');
	const [emailConfig, setEmailConfig] = useState({
		emailOnCustomerRegstration: {
			status: false,
			emailTempalteId: '',
		},
	});
	const [loader, setLoader] = useState(false);
	const dispatch = useDispatch();

	const fetch = async () => {
		setLoader(true);
		await clearCustomer();
		const token = JSON.parse(localStorage.getItem('token_gen'));
		let id = localStorage.getItem('Id');
		await dispatch(
			getCustomer(
				token?.access_token,
				id,
				Number(localStorage.getItem('CusPageIndex')) ?? 1,
				50,
				' ',
				testAccounts,
			),
		);
		setTimeout(() => {
			setLoader(false);
		}, 1000);
	};

	//   const fetchCustomer = async () => {
	// 	let tempToken = JSON.parse(localStorage.getItem("token_gen"));
	// 	tempToken = tempToken?.access_token;
	// 	const res = await dispatch(customerView(tempToken, customerPath))
	// 	setResponse(res);
	//   };

	async function generateValidPLPID() {
		while (true) {
			const newId = generatePLPPrimeID(); // your prime-digit ID generator

			try {
				const token = JSON.parse(localStorage.getItem('token_gen'));
				const res = await checkCustomerPLPID(token?.access_token, {
					plpId: newId,
				});
				// Assuming API returns something like:
				if (res?.message === 'Invalid Credentials') {
					return newId; // unique → return final ID
				}
			} catch (err) {
				// If API throws 404 or similar = means NOT found → valid ID
				return newId;
			}

			// If exists → loop again and generate new one
		}
	}

	async function registerCustomerWithRetry(token, processedFormData) {
		while (true) {
			try {
				// Try registering customer
				const custRes = await customerRegistrations(
					token,
					processedFormData,
				);

				// Success → break loop and return response
				if (custRes?.message === 'Request processed successfully.') {
					return custRes;
				}

				// Customer exists → regenerate PLP ID and try again
				if (custRes?.message === 'Customer Already exists') {
					processedFormData.plpId = await generateValidPLPID();
					continue; // retry
				}

				// Any other error → throw it
				throw new Error(custRes?.message || 'Unknown error');
			} catch (err) {
				console.error('Registration failed:', err);

				// retry for customer-exists only
				if (err.message.includes('Customer Already exists')) {
					processedFormData.plpId = await generateValidPLPID();
					continue;
				}

				// For all other errors → stop
				throw err;
			}
		}
	}

	const handleSubmit = async () => {
		if (Object.keys(errors).length > 0) {
			alert('Please fix validation errors before submitting.');
			return;
		}

		const emailFieldKey = Object.keys(schema).find(
			(key) => schema[key]?.fielddisplayname?.toLowerCase() === 'email',
		);

		// const agentIdValue = formData["agentId"]?.trim() || "";

		// if (!agentIdValue) {
		//     setErrors((prev) => ({
		//         ...prev,
		//         agentId: "Agent Id is required",
		//     }));
		//     return;
		// }

		if (formData.notificationsEnabled) {
			if (
				!formData[emailFieldKey] ||
				formData[emailFieldKey].trim() === ''
			) {
				setErrors((prev) => ({
					...prev,
					[emailFieldKey]:
						'Email is required when notifications are enabled.',
				}));
				return;
			}
		} else {
			setErrors((prev) => {
				const newErrors = { ...prev };
				delete newErrors[emailFieldKey];
				return newErrors;
			});
		}

		try {
			setLoading(true);
			setApiError(null);
			const token = JSON.parse(localStorage.getItem('token_gen'));
			const processedFormData = {};
			Object.keys(formData).forEach((key) => {
				const field = schema[key];
				if (isEditMode && field?.isPrimaryIdent) {
					return;
				}
				if (key === 'notificationsEnabled') return;
				processedFormData[key] = formData[key];
				if (
					(field?.fielddatatype === 'Integer' ||
						field?.type === 'number') &&
					processedFormData[key]
				) {
					processedFormData[key] = parseInt(
						processedFormData[key],
						10,
					);
				}
			});
			if (isEditMode) {
				Object.keys(processedFormData).forEach((key) => {
					if (key === 'status') return;
					const value = processedFormData[key];
					if (
						value === '' ||
						value === null ||
						value === undefined ||
						value === 0 ||
						(typeof value === 'object' &&
							Object.keys(value).length === 0)
					) {
						delete processedFormData[key];
					}
				});
				const res = await updateCustomer(
					token?.access_token,
					selectedCustomer.customercode,
					processedFormData,
				);
				if (res.message === 'Request processed successfully.') {
					setShowModal(false);
					// await fetch();
					// await fetchCustomer()
					fetchData ? await fetchData() : await fetch();
					swal({
						position: 'center',
						icon: 'success',
						title: 'Customer details update successfully',
						showConfirmButton: false,
						timer: 5000,
					});
				} else {
					setApiError(
						res?.errors?.[0]?.detail ||
						'An error occurred while updating the customer.',
					);
				}
			} else {
				let custRes;
				if (id === edsringMerchantId) {
					custRes = await registerCustomerWithRetry(
						token?.access_token,
						processedFormData,
					);
				} else {
					custRes = await customerRegistrations(
						token?.access_token,
						processedFormData,
					);
				}

				if (custRes?.message === 'Request processed successfully.') {
					const id = localStorage.getItem('Id');
					const res = await getEmailTemplateSetting(
						token?.access_token,
						id,
					);
					const template = res?.data?.EmailTemplateSetting?.filter(
						(template) =>
							template.id ===
							emailConfig?.emailOnCustomerRegstration
								?.emailTempalteId,
					);
					const tempBody = template?.[0]?.Body?.replace(
						/{{agentFirstName}}/g,
						formData.agentFirstName || 'User',
					)?.replace(
						/\[PORTAL_URL\]/g,
						'https://edsring.novusloyalty.com',
					);
					if (formData.notificationsEnabled) {
						const body = {
							subject: template?.[0]?.Subject,
							sendgridApiKey: template?.[0]?.sendgridApiKey,
							fromEmail: template?.[0]?.fromEmail,
							fromName: template?.[0]?.fromName,
							emails: [
								{
									Name:
										formData.agentFirstName ||
										formData.agentLastName ||
										'User',
									email: formData.email,
									customercode: encryptionByAES(
										custRes?.data?.customercode,
									),
								},
							],
							body: tempBody,
							purpose: 'Welcome Email',
							fileName: '',
						};
						await SendGridEmail(token?.access_token, body);
					}
					setShowModal(false);
					await fetch();
					swal({
						position: 'center',
						icon: 'success',
						title: decrypt(localStorage.getItem('Id')) === edsringMerchantId ? `Customer registered successfully. Customer PLP ID is ${custRes?.data?.plpId}` : 'Customer registered successfully',
						showConfirmButton: false,
						timer: 5000,
					});
				} else {
					custRes?.message !== 'Customer Already exists' &&
						id === edsringMerchantId
						? <></>
						: setApiError(
							custRes.message ||
							'An error occurred while creating the customer.',
						);
				}
			}
		} catch (error) {
			setApiError(
				error.response?.data?.message ||
				`An error occurred while ${isEditMode ? 'updating' : 'creating'
				} the customer.`,
			);
		} finally {
			setLoading(false);
		}
	};

	const disposableDomains = [
		'mailinator.com',
		'tempmail.com',
		'10minutemail.com',
		'guerrillamail.com',
		'dispostable.com',
		'mail.com',
	];

	const formatMobileNumber = (value) => {
		if (!value) return '';

		let digits = value.replace(/\D/g, '');

		if (digits.startsWith('0')) {
			digits = digits.slice(1);
		} else if (digits.startsWith('61')) {
			digits = digits.slice(2);
		}

		let formatted = '+61 ';

		if (digits.length <= 3) {
			formatted += digits;
		} else if (digits.length <= 6) {
			formatted += `${digits.slice(0, 3)} ${digits.slice(3)}`;
		} else {
			formatted += `${digits.slice(0, 3)} ${digits.slice(
				3,
				6,
			)} ${digits.slice(6, 9)}`;
		}

		return formatted;
	};

	const handleChange = (key, value, field) => {
		if (isEditMode && field?.isPrimaryIdent) return;

		let newErrors = { ...errors };
		if (
			field.fielddatatype !== 'Boolean' &&
			field.fielddatatype !== 'Enumeration'
		) {
			if (value.startsWith(' ')) {
				newErrors[key] = 'Leading spaces are not allowed';
				setErrors(newErrors);
				setFormData((prev) => ({ ...prev, [key]: value }));
				return;
			}
			if (value.endsWith(' ')) {
				newErrors[key] = 'Trailing spaces are not allowed';
				setErrors(newErrors);
				setFormData((prev) => ({ ...prev, [key]: value }));
				return;
			}

			delete newErrors[key];
		}

		let processedValue = value;

		if (field?.fielddatatype === 'Integer' || field?.type === 'number') {
			processedValue = value ? parseInt(value, 10) : '';

			if (
				value &&
				(!Number.isInteger(Number(value)) || Number(value) < 0)
			) {
				newErrors[key] = 'Must be a valid non-negative integer';
			} else {
				delete newErrors[key];
			}
		}

		if (key === 'agentFirstName' || key === 'agentLastName') {
			const minLen = field?.minLength || null;
			const maxLen = field?.maxLength || null;
			if (value && minLen && value.length < minLen) {
				newErrors[key] = `Minimum ${minLen} characters required`;
			} else if (value && maxLen && value.length > maxLen) {
				newErrors[key] = `Maximum ${maxLen} characters allowed`;
			} else {
				delete newErrors[key];
			}
		}

		if (field?.fielddisplayname?.toLowerCase() === 'email') {
			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

			if (value && !emailRegex.test(value)) {
				newErrors[key] = 'Invalid email';
			} else {
				if (value) {
					const domain = value.split('@')[1]?.toLowerCase();
					if (disposableDomains.includes(domain)) {
						newErrors[key] = 'Disposable emails are not allowed';
					} else {
						delete newErrors[key];
					}
				}
			}
		}

		setErrors(newErrors);
		setFormData((prev) => ({ ...prev, [key]: processedValue }));
	};

	const isFormValid = () => {
		if (Object.keys(errors).length > 0) {
			return false;
		}
		return Object.keys(formData).some((key) => {
			return formData[key] !== undefined && formData[key] !== '';
		});
	};

	const handleEditCustomerClick = async (customer) => {
		setShowModal(true);
		setIsEditMode(true);
		setSelectedCustomer(customer);
		setLoading(true);
		setApiError(null);
		setCustomerStatus(customer?.status || 0);

		try {
			const token = JSON.parse(localStorage.getItem('token_gen'));
			const tedata = await getSchemaList(token?.access_token);
			const schemaProps = tedata?.schema?.properties || {};
			const updatedSchema = { ...schemaProps };
			Object.keys(updatedSchema).forEach((key) => {
				if (key === 'agentFirstName' || key === 'agentLastName') {
					updatedSchema[key] = {
						...updatedSchema[key],
						minLength: 2,
						maxLength: 50,
					};
				}
			});
			setSchema(updatedSchema);

			const prefilledData = {};
			Object.keys(schemaProps).forEach((key) => {
				if (schemaProps[key].isFormView) {
					let value = customer[key] ?? '';
					prefilledData[key] = value;
				}
				if (customer?.status) {
					prefilledData['status'] = customer?.status;
				}
			});
			setFormData(prefilledData);
		} catch (e) {
			console.error(e);
		} finally {
			setLoading(false);
		}
	};
	const handleCreateCustomerClick = async () => {
		setShowModal(true);
		setIsEditMode(false);
		let finalPLPID = null;

		try {
			finalPLPID = await generateValidPLPID();
		} catch (error) {
			console.error('Error generating PLP ID:', error);
		}

		setFormData({
			...(id === edsringMerchantId && {
				notificationsEnabled: true,
				monthlyPointsStatement: true,
				programUpdatesAndNews: true,
				specialOffersAndPromotion: true,
				smsnotification: true,
				transaction: true,
				plpId: finalPLPID,
			}),
		});
		setErrors({});
		setLoading(true);
		setApiError(null);
		try {
			const token = JSON.parse(localStorage.getItem('token_gen'));
			const tedata = await getSchemaList(token?.access_token);
			const res = await getCustomerPortalSetting(token?.access_token);
			if (res.message === 'Settings retrieved successfully') {
				setEmailConfig((prev) => ({
					...prev,
					emailOnCustomerRegstration:
						res?.data?.emailSetting?.EmailOnCustomerRegstration,
				}));
			}
			const updatedSchema = tedata?.schema?.properties || {};
			Object?.keys(updatedSchema)?.forEach((key) => {
				if (key === 'agentFirstName' || key === 'agentLastName') {
					updatedSchema[key] = {
						...updatedSchema[key],
						minLength: 2,
						maxLength: 50,
					};
				}
			});
			setSchema(updatedSchema);
		} catch (e) {
			console.error(e);
		} finally {
			setLoading(false);
		}
	};
	return (
		<>
			{loader && (
				<div className='mainPreloaderMain'>
					<div className='mainPreloader'>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
					</div>
				</div>
			)}
			{isEdit ? (
				<Link
					to=''
					onClick={() => handleEditCustomerClick(customerData)}
					className='edit_btn'
					csvalue='Edit'>
					<i className='fa-solid fa-pen'></i>
					{isEditToolTip ? (
						<div className='show_div'>Edit</div>
					) : (
						<></>
					)}
				</Link>
			) : (
				<button
					className='btn btn-default'
					onClick={handleCreateCustomerClick}>
					Add Customer
				</button>
			)}
			<Modal
				show={showModal}
				onHide={() => setShowModal(false)}
				size='lg'>
				<Modal.Header closeButton>
					<Modal.Title>
						{isEditMode ? 'Edit Customer' : 'Add Customer'}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{apiError && <Alert variant='danger'>{apiError}</Alert>}
					{loading ? (
						<div
							className='loader-container'
							style={{
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								padding: '10px',
							}}>
							<ClipLoader
								color={'#D000218'}
								loading={loading}
								size={50}
							/>
						</div>
					) : (
						<Form>
							<Row>
								{Object.keys(rearrangeAgentFields(schema)).map(
									(key, idx) => {
										const field = schema[key];
										if (!field?.isFormView) return null;
										const isReadOnly =
											id === edsringMerchantId &&
												field?.fielddisplayname === 'PLP Id'
												? true
												: isEditMode &&
												field?.isPrimaryIdent;
										const isSecondaryIdent =
											isEditMode && field?.isident;
										return (
											<Col
												md={6}
												key={key}>
												<Form.Group className='mb-3'>
													{id === edsringMerchantId ? (
														field?.fielddisplayname !==
															'Mark as Test Account' ? (
															<Form.Label>
																{
																	field?.fielddisplayname
																}
															</Form.Label>
														) : (
															<></>
														)
													) : (
														<Form.Label>
															{
																field?.fielddisplayname
															}
														</Form.Label>
													)}
													{(isReadOnly ||
														isSecondaryIdent) && (
															<span class='text-danger'>
																*
															</span>
														)}
													{isReadOnly ? (
														<Form.Control
															className='custom_disabled'
															type='text'
															value={
																formData[key] ||
																''
															}
															disabled
															readOnly
														/>
													) : field?.fielddisplayname?.toLowerCase() ===
														'email' ? (
														<>
															<Form.Control
																// type="email"
																value={
																	formData[
																	key
																	] || ''
																}
																placeholder='Enter email'
																onChange={(e) =>
																	handleChange(
																		key,
																		e.target
																			.value,
																		field,
																	)
																}
																isInvalid={
																	!!errors[
																	key
																	]
																}
															/>
															{errors[field] && (
																<div className='text-danger mt-1'>
																	{
																		errors[
																		field
																		]
																	}
																</div>
															)}
														</>
													) : field?.fielddisplayname
														?.toLowerCase()
														.includes(
															'mobile',
														) ||
														field?.fielddisplayname
															?.toLowerCase()
															.includes(
																'phone',
															) ? (
														<Form.Control
															type='text'
															maxLength={
																id ===
																	edsringMerchantId
																	? 15
																	: null
															}
															inputMode='numeric'
															placeholder={
																id ===
																	edsringMerchantId
																	? '+61 411 222 333'
																	: ''
															}
															value={
																id ===
																	edsringMerchantId
																	? formatMobileNumber(
																		formData[
																		key
																		] ||
																		'',
																	)
																	: formData[
																	key
																	] || ''
															}
															onChange={(e) => {
																const rawValue =
																	e.target.value.replace(
																		/\D/g,
																		'',
																	);
																handleChange(
																	key,
																	rawValue,
																	field,
																);
															}}
															isInvalid={
																!!errors[key]
															}
														/>
													) : field?.fielddatatype ===
														'String' ? (
														<Form.Control
															type='text'
															placeholder={`Enter ${field.fielddisplayname?.toLowerCase()}`}
															value={
																formData[key] ||
																''
															}
															onChange={(e) =>
																handleChange(
																	key,
																	e.target
																		.value,
																	field,
																)
															}
															isInvalid={
																!!errors[key]
															}
														/>
													) : field?.fielddatatype ===
														'Integer' ||
														field?.type ===
														'number' ? (
														<Form.Control
															type='number'
															step='1'
															value={
																formData[key] ||
																''
															}
															onChange={(e) =>
																handleChange(
																	key,
																	e.target
																		.value,
																	field,
																)
															}
															isInvalid={
																!!errors[key]
															}
														/>
													) : field?.fielddatatype ===
														'Enumeration' ? (
														<Form.Select
															value={
																formData[key] ||
																''
															}
															onChange={(e) =>
																handleChange(
																	key,
																	e.target
																		.value,
																	field,
																)
															}
															isInvalid={
																!!errors[key]
															}>
															<option value=''>
																Select
															</option>
															{field?.enum?.map(
																(val, i) => (
																	<option
																		key={i}
																		value={
																			val
																		}>
																		{val}
																	</option>
																),
															)}
														</Form.Select>
													) : field?.fielddatatype ===
														'Boolean' ? (
														<>
															{id ===
																edsringMerchantId ? (
																<Row>
																	<Col
																		md={12}>
																		<div class='checkbox-block'>
																			<label class='custom-checkbox'>
																				<input
																					type='checkbox'
																					aria-invalid={
																						!!errors[
																						key
																						]
																					}
																					onChange={(
																						e,
																					) =>
																						handleChange(
																							key,
																							e
																								.target
																								.checked,
																							field,
																						)
																					}
																					checked={
																						formData[
																							key
																						] ===
																							true
																							? true
																							: formData[
																								key
																							] ===
																								false
																								? false
																								: false
																					}
																				/>
																				<span class='checkmark'></span>
																			</label>

																			<div class='checkbox-text'>
																				<h5>
																					Mark
																					as
																					Test
																					Account
																				</h5>
																				<p>
																					Test
																					accounts
																					are
																					excluded
																					from
																					regular
																					reports
																					and
																					analytics.
																					Only
																					use
																					for
																					testing
																					purposes.
																				</p>
																			</div>
																		</div>
																	</Col>
																</Row>
															) : (
																<Form.Select
																	value={
																		formData[
																			key
																		] ===
																			true
																			? 'true'
																			: formData[
																				key
																			] ===
																				false
																				? 'false'
																				: ''
																	}
																	onChange={(
																		e,
																	) =>
																		handleChange(
																			key,
																			e
																				.target
																				.value ===
																			'true',
																			field,
																		)
																	}
																	isInvalid={
																		!!errors[
																		key
																		]
																	}>
																	<option value=''>
																		Select
																	</option>
																	<option value='true'>
																		True
																	</option>
																	<option value='false'>
																		False
																	</option>
																</Form.Select>
															)}
														</>
													) : null}
													<Form.Control.Feedback type='invalid'>
														{errors[key]}
													</Form.Control.Feedback>
												</Form.Group>
											</Col>
										);
									},
								)}
								{isEditMode && (
									<Col md={6}>
										<div className='mt-2'>
											<Form.Label>
												Customer Status:{' '}
												<strong
													style={{
														color:
															customerStatus === 2
																? 'red'
																: 'green',
													}}>
													{customerStatus === 2
														? 'Deactivated'
														: 'Active'}
												</strong>
											</Form.Label>
											{/* {formData?.status !== 2 && <Button onClick={() => {
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        status: (prev.status === 1) ? 0 : 1
                                                    }))
                                                }}>{(formData?.status === 0 || !formData?.status) ? "Active" : formData?.status === 1 ? "In Active" : ""}</Button>} */}
											<div className='d-flex gap-2 mt-2'>
												<Button
													variant='success'
													disabled={
														formData?.status !== 2
													}
													onClick={() =>
														setFormData((prev) => ({
															...prev,
															status: 0,
														}))
													}>
													Activate
												</Button>

												<Button
													variant='danger'
													disabled={
														formData?.status === 2
													}
													onClick={() =>
														setFormData((prev) => ({
															...prev,
															status: 2,
														}))
													}>
													Deactivate
												</Button>
											</div>
										</div>
									</Col>
								)}
							</Row>
							<Row>
								{!isEditMode &&
									emailConfig?.emailOnCustomerRegstration
										?.status ? (
									<Col md={3}>
										<div className='d-flex align-items-center justify-content-between'>
											<Form.Label className='mb-0'>
												{id === edsringMerchantId
													? 'Send Welcome Email'
													: 'Send Notification'}
											</Form.Label>
											<Form.Check
												type='switch'
												id='notificationToggle'
												checked={
													formData.notificationsEnabled ||
													false
												}
												onChange={(e) => {
													const checked =
														e.target.checked;

													if (checked) {
														setFormData({
															...formData,
															notificationsEnabled: true,
															...(id ===
																edsringMerchantId && {
																monthlyPointsStatement: true,
																programUpdatesAndNews: true,
																specialOffersAndPromotion: true,
																smsnotification: true,
																transaction: true,
															}),
														});
													} else {
														setFormData({
															...formData,
															notificationsEnabled: false,
															...(id ===
																edsringMerchantId && {
																monthlyPointsStatement: false,
																programUpdatesAndNews: false,
																specialOffersAndPromotion: false,
																smsnotification: false,
																transaction: false,
															}),
														});

														const emailFieldKey =
															Object.keys(
																schema,
															).find(
																(key) =>
																	schema[
																		key
																	]?.fielddisplayname?.toLowerCase() ===
																	'email',
															);

														setErrors((prev) => {
															const newErrors = {
																...prev,
															};
															if (
																newErrors[
																emailFieldKey
																] ===
																'Email is required when notifications are enabled.'
															) {
																delete newErrors[
																	emailFieldKey
																];
															}
															return newErrors;
														});
													}
												}}
											/>
										</div>
									</Col>
								) : (
									<></>
								)}
							</Row>
						</Form>
					)}
				</Modal.Body>
				<Modal.Footer className='footer_start'>
					<div className='modal-footer-custom'>
						{isEditMode ? (
							<div className='modal-footer-custom-left'>
								<p>
									<span>*</span>Identification field
								</p>
							</div>
						) : (
							<></>
						)}
						<div className='modal-footer-custom-right'>
							<Button
								variant='secondary'
								onClick={() => setShowModal(false)}>
								Cancel
							</Button>
							<Button
								variant='primary'
								onClick={handleSubmit}
								disabled={!isFormValid()}>
								{isEditMode ? 'Update' : 'Add'}
							</Button>
						</div>
					</div>
				</Modal.Footer>
			</Modal>
		</>
	);
}

export default CustomerAddEditModal;
